export function getDate(value: Date) {
    return value.toLocaleDateString([], {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });
}

export function getTime(value: Date) {
    return value.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// 2022 - 03 - 11
